module.exports = __webpack_public_path__ + "a8cfbb7433a63f48982f9fa90e17a739.pdf";